import styles from "./Notifications.module.css";

import avatarAngelaGray from "../src/images/avatarAngelaGray.webp";
import avatarRizkyHasanuddin from "../src/images/avatarRizkyHasanuddin.webp";
import avatarMarkWebber from "../src/images/avatarMarkWebber.webp";
import avatarJacobThompson from "../src/images/avatarJacobThompson.webp";
import avatarKimberlySmith from "../src/images/avatarKimberlySmith.webp";
import avatarNathanPeterson from "../src/images/avatarNathanPeterson.webp";
import avatarAnnaKim from "../src/images/avatarAnnaKim.webp";
import imageChess from "../src/images/imageChess.webp";
import HotNotification from "./HotNotification";

function Notifications({ isNewNotification }) {
  return (
    <ul className={styles.notifications}>
      <li className={isNewNotification ? styles.new : {}}>
        <img src={avatarMarkWebber} alt="Avatar Mark Webber" />
        <div>
          <div>
            <strong>Mark Webber</strong> reacted to your recent post{" "}
            <strong>My first tournament today!</strong>
            {isNewNotification && <HotNotification />}
          </div>
          <p>1m ago</p>
        </div>
      </li>

      <li className={isNewNotification ? styles.new : {}}>
        <img src={avatarAngelaGray} alt="Avatar Angela Gray" />
        <div>
          <span>
            <strong>Angela Gray</strong> followed you
            {isNewNotification && <HotNotification />}
          </span>
          <p>5m ago</p>
        </div>
      </li>

      <li className={isNewNotification ? styles.new : {}}>
        <img src={avatarJacobThompson} alt="Jacob Thompson" />
        <div>
          <div>
            <strong>Jacob Thompson </strong> has joined your group{" "}
            <strong className={styles.chessClub}>Chess Club</strong>
            {isNewNotification && <HotNotification />}
          </div>
          <p>1 day ago</p>
        </div>
      </li>

      <li>
        <img
          className={styles.special}
          src={avatarRizkyHasanuddin}
          alt="Avatar Rizky Hasanuddin"
        />
        <div>
          <span>
            <strong>Rizky Hasanuddin</strong> sent you a private message
          </span>
          <p>5 days ago</p>

          <p className={styles.privateMessage}>
            Hello, thanks for setting up the Chess Club. I've been a member for
            a few weeks now and I'm already having lots of fun and improving my
            game.
          </p>
        </div>
      </li>

      <li>
        <img src={avatarKimberlySmith} alt="Avatar Kimberly Smith" />
        <div>
          <span>
            <strong>Kimberly Smith</strong> commented on your picture
          </span>
          <p>1 week ago</p>
        </div>
        <img src={imageChess} alt="Chess" className={styles.chessImage} />
      </li>

      <li>
        <img src={avatarNathanPeterson} alt="Avatar Nathan Peterson" />
        <div>
          <span>
            <strong>Nathan Peterson</strong> reacted to your recent post 5
            end-game strategies to increase your win rate
          </span>{" "}
          <p>2 weeks ago</p>
        </div>
      </li>

      <li>
        <img src={avatarAnnaKim} alt="Avatar Anna Kim" />
        <div>
          <div>
            <strong>Anna Kim</strong> left the group{" "}
            <strong className={styles.chessClub}>Chess Club</strong>
          </div>
          <p>2 weeks ago</p>
        </div>
      </li>
    </ul>
  );
}

export default Notifications;
